import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import NRCreateVulnerabilityJiraTicketFields from './NRCreateVulnerabilityJiraTicketFields';
import NRCreateVulnerabilityJiraTicketSummary from './NRCreateVulnerabilityJiraTicketSummary';
import { useCreateVulnerabilityJiraTicket } from './useCreateVulnerabilityJiraTicket';

function NRCreateVulnerabilityJiraTicket({ vulnerabilityData = {}, cveDetails = {}, assetId, advisoryId }) {
  const theme = useTheme();
  const form = useCreateVulnerabilityJiraTicket({ vulnerabilityData, assetId, advisoryId });

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          px: theme.spacing(3),
          py: theme.spacing(2),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2.5)
        }}
      >
        <NRCreateVulnerabilityJiraTicketSummary vulnerabilityData={vulnerabilityData} cveDetails={cveDetails} />
        <NRCreateVulnerabilityJiraTicketFields form={form} />
      </Box>
    </Box>
  );
}

export default NRCreateVulnerabilityJiraTicket;
